export var ExtensionEnvironment = /*#__PURE__*/function (ExtensionEnvironment) {
  ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
  ExtensionEnvironment["STAGING"] = "STAGING";
  ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
  return ExtensionEnvironment;
}({});

// duplicated ReferenceEntity from @atlaskit/editor-common to avoid adding @atlaskit/editor-common as a dependency

export var ConfluenceExtension = {
  BYLINE: 'confluence:contentBylineItem',
  CONTEXT_MENU: 'confluence:contextMenu',
  CONTENT_ACTION: 'confluence:contentAction',
  GLOBAL_PAGE: 'confluence:globalPage',
  GLOBAL_SETTINGS: 'confluence:globalSettings',
  HOMEPAGE_FEED: 'confluence:homepageFeed',
  SPACE_PAGE: 'confluence:spacePage',
  SPACE_SETTINGS: 'confluence:spaceSettings',
  CUSTOM_CONTENT: 'confluence:customContent',
  TEST_MODULE: 'test:module'
};
export var JiraExtension = {
  ISSUE_PANEL: 'jira:issuePanel',
  ISSUE_ACTION: 'jira:issueAction',
  ISSUE_GLANCE: 'jira:issueGlance',
  ISSUE_CONTEXT: 'jira:issueContext',
  ISSUE_ACTIVITY: 'jira:issueActivity',
  UI_MODIFICATIONS: 'jira:uiModifications',
  CUSTOM_FIELD: 'jira:customField',
  CUSTOM_FIELD_TYPE: 'jira:customFieldType',
  ADMIN_PAGE: 'jira:adminPage',
  GLOBAL_PAGE: 'jira:globalPage',
  PROJECT_PAGE: 'jira:projectPage',
  PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
  DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
  ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
  DASHBOARD_GADGET: 'jira:dashboardGadget',
  WORKFLOW_VALIDATOR: 'jira:workflowValidator',
  WORKFLOW_CONDITION: 'jira:workflowCondition',
  WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
  SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
  SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};